<template>
  <div class="about">
    <homePage></homePage>
  </div>
</template>
<script>
import homePage from "../components/homePage.vue";
export default {
  components: {
    homePage,
  },
};
</script>
